import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";

import Form from "../../common/form";
import FormHeader from "../../common/form/formHeader";
import FormFooter from "../../common/form/formFooter";

import {
  getEntity,
  saveEntity,
  getMaxPriority,
} from "../../../services/apiService";

class CategoryForm extends Form {
  state = {
    data: {
      priority: 1,
      name_de: "",
      name_en: "",
    },
    pois: [],
    errors: {},
    maxPriority: "",
  };

  schema = {
    _id: Joi.string(),
    priority: Joi.number().integer().min(1).label("Priority"),
    name_de: Joi.string().min(3).max(100).required().label("Name (German)"),
    name_en: Joi.string().min(3).max(100).required().label("Name (English)"),
  };

  // Retrive the Data from the Server
  async componentDidMount() {
    // Get the maximum Priority
    const { data: max } = await getMaxPriority("category");

    // Get the Given ID
    const category_id = this.props.match.params.id;

    if (category_id === "new") {
      const data = { ...this.state.data };

      if (max.length === 0) {
        data.priority = 1;
        return this.setState({ data, maxPriority: 1 });
      } else {
        data.priority = max[0].priority + 1;
        return this.setState({ data, maxPriority: max[0].priority });
      }
    }

    // Get Poi related to the Given ID
    const { data: category } = await getEntity("category", category_id);
    if (!category) return this.props.history.replace("/not-found");

    this.setState({
      data: this.mapToViewModel(category),
      maxPriority: max[0].priority,
    });
  }

  // Map current Poi to the Form Inputs
  mapToViewModel(category) {
    return {
      _id: category._id,
      priority: category.priority,
      name_en: category.name_en,
      name_de: category.name_de,
    };
  }

  doSubmit = async () => {
    // Save Item to the Database
    try {
      const response = await saveEntity("category", this.state.data);

      if (response.data && response.status === 200) {
        toast.success(
          <div>
            Category: "{response.data.name_en}"
            <br /> saved successfully.
          </div>
        );
      }
    } catch (ex) {
      toast.error(ex.response?.message ?? ex.response.data?.message);

      return;
    }

    // Return to Categories TableView after saving
    this.handleBack();
  };

  // Back button Event Handler
  handleBack = () => {
    // Table Pagination Query
    const searchParams = new URLSearchParams(window.location.search);
    const currentPageQuery = searchParams.get("currentPage");
    const pageSizeQuery = searchParams.get("pageSize");

    // Return to Categories TableView after saving
    if (currentPageQuery && pageSizeQuery) {
      this.props.history.push(
        `/dashboard/categories?pageSize=${pageSizeQuery}&currentPage=${currentPageQuery}`
      );
    } else {
      this.props.history.push("/dashboard/categories");
    }
  };

  render() {
    const id = this.props.match.params.id;
    const { errors } = this.state;

    return (
      <div className="col alt-table-responsive">
        <FormHeader name="Category" icon="bx bxs-category-alt" id={id} />
        <form onSubmit={this.handleSubmit} className="form-group">
          <div className="row pt-2 mt-2">
            <div className=" col-sm-6">
              <div className="row align-items-center">
                <div className="col-sm-4">
                  {this.renderPriority("priority", "Priority")}
                </div>
              </div>

              <hr />

              <div className="row mt-4">
                <div className="col">
                  {this.renderInput("name_en", "Name | English")}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {this.renderInput("name_de", "Name | Deutsch")}
                </div>
              </div>
            </div>

            <div className=" col-sm-6 border-left">
              <div className="row">
                <div className="col"> {this.renderErrors(errors)}</div>
              </div>
            </div>
          </div>
          <FormFooter
            onBackClick={this.handleBack}
            onValidate={this.validate()}
          />
        </form>
      </div>
    );
  }
}

export default CategoryForm;
